// @type
import React from 'react';

import Text from './shared/Typography';
import Card from './shared/Card';
import Icon from './shared/Icon';

type Props = {
  name: string,
  address: {}
}

const ResourceAddressCard = ({ name, address }: Props) => (
  <Card noShadow className='record-detail__card'>
    <address>
      <Icon name='pin' size='medium' />
      <div>
        <Text paragraph bold>{name}</Text>
        <Text paragraph>{address.address}</Text>
        <Text paragraph>{address.city}{address.province && `, ${address.province}`}</Text>
        <Text paragraph>{address.country}</Text>
        <Text paragraph>{address.postal_code}</Text>
      </div>
    </address>
  </Card>
);

export default ResourceAddressCard;


// WEBPACK FOOTER //
// ./src/components/resource-address-card.js